import { useTranslation } from 'react-i18next';
import { ReactComponent as Logo } from '$icons/simera-dark logo.svg';
import { Link } from 'react-router-dom';
import EmployerRegisterForm from '$components/RegisterForm/EmployerRegisterForm';

const EmployerRegisterScreen = () => {
  const [t] = useTranslation('global');
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-spk-offWhite font-mulish text-spk-highContrast pt-24 pb-2 gap-9">
      <div className="flex flex-col gap-9">
        <div className="flex gap-28 justify-center">
          <div className="w-1/3 flex flex-col gap-4 relative">
            <div className="flex flex-row gap-3 justify-center self-start absolute -top-12">
              <Logo className="w-24 " />
              <div className="flex items-center justify-center w-fit bg-spk-highContrast rounded-md px-1.5">
                <p className="text-sm font-bold text-spk-softBlue110">
                  {t('register.employerTag')}
                </p>
              </div>
            </div>
            <h1 className="text-5xl font-black m-0">
              {t('register.employerTitle')}
            </h1>
            <p className="text-spk-mediumContrast">
              {t('register.alreadyHave')}&nbsp;
              <Link
                to="/employer_login"
                className="text-spk-brightBlue font-bold underline"
              >
                {t('register.logIn')}
              </Link>
            </p>
          </div>
          <div className="">
            <EmployerRegisterForm />
          </div>
        </div>
      </div>
      <div className="">
        <p className="text-spk-mediumContrast">
          {t('register.areYouCandidate')}&nbsp;
          <Link to="/login" className="text-spk-brightBlue font-bold">
            {t('register.startHere')}
          </Link>
        </p>
      </div>
    </div>
  );
};

export default EmployerRegisterScreen;
